import React, { useState, useEffect, useCallback } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, addDoc, getDocs, query, where, doc, updateDoc, orderBy, deleteDoc, limit, onSnapshot } from "firebase/firestore";


import { format, parseISO, isToday, isAfter, isBefore, addDays, set } from 'date-fns';
import { Badge, List, Avatar, Divider, Typography, Alert } from 'antd';
import { BellOutlined, CalendarOutlined, ExclamationCircleOutlined } from '@ant-design/icons';


import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";



import dayjs from "dayjs";
import './body.css';


import { Eye, Download } from "lucide-react";

const db = getFirestore();

const { Title, Text } = Typography;

const Body = () => {
// Settle Invoice States
const [searchInvoiceNo, setSearchInvoiceNo] = useState("");
const [foundInvoice, setFoundInvoice] = useState(null);
const [settleAmount, setSettleAmount] = useState("");
const [balanceAfterSettle, setBalanceAfterSettle] = useState(0);


  const [eyeExams, setEyeExams] = useState([]);

  useEffect(() => {
    // Listen for invoices
    const qInvoices = query(collection(db, "invoices"), orderBy("createdAt", "desc"));
    const unsubInvoices = onSnapshot(qInvoices, (snapshot) => {
      setInvoices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Listen for patients
    const qPatients = query(collection(db, "patients"), orderBy("createdAt", "desc"));
    const unsubPatients = onSnapshot(qPatients, (snapshot) => {
      setPatients(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Listen for eye exams
    const qEyeExams = query(collection(db, "eyeExams"), orderBy("createdAt", "desc"));
    const unsubEyeExams = onSnapshot(qEyeExams, (snapshot) => {
      setEyeExams(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Clean up all listeners on unmount
    return () => {
      unsubInvoices();
      unsubPatients();
      unsubEyeExams();
    };
  }, []);








  const [selectedOption, setSelectedOption] = useState("addPatient"); // Default to "home"
  const [userDetails, setUserDetails] = useState(null); // Define userDetails state
  const auth = getAuth(); // Initialize Firebase Auth
  const navigate = useNavigate(); // Initialize navigate
  const db = getFirestore(); // Initialize Firestore



//fetch all the eye exam report
const [eyeExamRecords, setEyeExamRecords] = useState([]);
const [selectedRecord, setSelectedRecord] = useState(null);


//search function in view eye report
const [filterOption, setFilterOption] = useState('all');



// Add Patient 
  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: '',
    sex: '',
    telephoneNo: '',
    mobileNo: '', 
    email: '',
    address: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'patients'), formData);
      alert('Patient added successfully!');
      // Reset form
      setFormData({
        name: '',
        dateOfBirth: '',
        sex: '',
        telephoneNo: '',
        mobileNo: '', 
        email: '',
        address: ''
      });
    } catch (error) {
      console.error('Error adding patient: ', error);
      alert('Error adding patient');
    }
  };



//Fetch all patients

const [patients, setPatients] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "patients"), (snapshot) => {
    const patientsData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    setPatients(patientsData);
    setLoading(false);
  }, (error) => {
    console.error("Error fetching patients:", error);
    setLoading(false);
  });

  return () => unsubscribe();
}, []);


// State variables
const [searchTerm, setSearchTerm] = useState("");
const [editingPatient, setEditingPatient] = useState(null);
const [filteredPatients, setFilteredPatients] = useState([]);

// Filter patients based on search term
// Filter patients based on search term
useEffect(() => {
  const filtered = patients.filter(patient =>
    patient.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    patient.telephoneNo?.toString().includes(searchTerm) // allow numeric match
  );
  setFilteredPatients(filtered);
}, [searchTerm, patients]);

// Handle patient update
const handleUpdatePatient = async (e) => {
  e.preventDefault();
  try {
    const patientRef = doc(db, "patients", editingPatient.id);
    await updateDoc(patientRef, editingPatient);
    setPatients(patients.map(p => p.id === editingPatient.id ? editingPatient : p));
    setEditingPatient(null);
    alert("Patient updated successfully!");
  } catch (error) {
    console.error("Error updating patient: ", error);
    alert("Error updating patient. Please try again.");
  }
};





// Add this function to delete a patient
const handleDeletePatient = async (patientId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this patient record?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "patients", patientId));
    setPatients(patients.filter(patient => patient.id !== patientId));
    alert("Patient deleted successfully!");
  } catch (error) {
    console.error("Error deleting patient: ", error);
    alert("Failed to delete patient.");
  }
};





// Export to Excel
const handleDownloadPatients = () => {
  if (filteredPatients.length === 0) {
    alert("No patient data to download.");
    return;
  }
  
  const worksheet = XLSX.utils.json_to_sheet(filteredPatients);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Patients");
  XLSX.writeFile(workbook, "patient_records.xlsx");
};











// to create invoice
// // --- Auto Generate Invoice Number ---
// const generateInvoiceNumber = async () => {
//   try {
//     const q = query(
//       collection(db, "invoices"),
//       orderBy("createdAt", "desc"),
//       limit(1)
//     );
//     const querySnapshot = await getDocs(q);

//     if (!querySnapshot.empty) {
//       const lastInvoice = querySnapshot.docs[0].data();
//       const lastNumber = parseInt(lastInvoice.invoiceNo, 10) || 0;
//       return formatInvoiceNumber(lastNumber + 1); // increment
//     } else {
//       return formatInvoiceNumber(1); // first invoice
//     }
//   } catch (error) {
//     console.error("Error generating invoice number:", error);
//     return formatInvoiceNumber(1);
//   }
// };

// // Utility to format invoice number with leading zeros
// const formatInvoiceNumber = (num) => {
//   return num.toString().padStart(3, "0"); // Example: 1 => "000000001"
// };



// to create invoice
 const [invoiceNumber, setInvoiceNumber] = useState(""); // Start Invoice No 
  const [to, setTo] = useState(""); // To field
  const [patientPhoneNo, setPatientPhoneNo] = useState(""); // Patient Phone No field 
  const [paymentMethod, setPaymentMethod] = useState("cash"); // Lens field
  const [date, setDate] = useState(""); // Date field
  const [frame, setFrame] = useState("");
  const [brand, setBrand] = useState("");
  const [rightLens, setRightLens] = useState("");
  const [leftLens, setLeftLens] = useState("");
  const [addPower, setAddPower] = useState(""); // Add Power field
  const [pd, setPd] = useState("");
  const [seg, setSeg] = useState("");
  // const [description, setDescription] = useState(""); // Description field
  const [amount, setAmount] = useState(""); // Amount field
  const [totalAmount, setTotalAmount] = useState(0); // Total amount
  const [deductAmount, setDeductAmount] = useState(""); // New state for deduct amount


// // ✅ Fetch invoice number as soon as the panel is opened
// useEffect(() => {
//   const fetchInvoiceNumber = async () => {
//     const newNumber = await generateInvoiceNumber();
//     setInvoiceNumber(newNumber);
//   };
//   fetchInvoiceNumber();
// }, []); // runs only once when panel loads





//01 create invoice
const handleCreateInvoice = async () => {
  if (!to || !date || !amount || deductAmount === undefined || !invoiceNumber) {
    window.alert("Please fill in all required fields before proceeding!");
    return;
  }

  try {
    // ❌ REMOVE THIS
    // const newInvoiceNumber = await generateInvoiceNumber();

    // ✅ USE USER INPUT
    const newInvoiceNumber = invoiceNumber; 

    const totalAmount = parseFloat(amount) - parseFloat(deductAmount);

    const invoiceData = {
      to: String(to).trim(),
      patientPhoneNo: String(patientPhoneNo).trim(),
      paymentMethod: String(paymentMethod).trim(),
      date: String(date).trim(),
      frame: String(frame).trim(),
      brand: String(brand).trim(),
      lens: String(lens).trim(),
      rightLens: String(rightLens).trim(),
      leftLens: String(leftLens).trim(),
      addPower: String(addPower).trim(),
      pd: String(pd).trim(),
      seg: String(seg).trim(),
      amount: parseFloat(amount) || 0,
      deductAmount: parseFloat(deductAmount) || 0,
      totalAmount: totalAmount || 0,
      invoiceNo: newInvoiceNumber,  // now correctly using user's input
      createdAt: new Date(),
    };

    await addDoc(collection(db, "invoices"), invoiceData);

    // ... your PDF code remains as it is ...


    // --- Generate PDF (your existing PDF code) ---
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [210, 148] });

    // --- Professional Font Setup ---
    doc.setFont("helvetica", "normal");
    

// --- Header ---
const headerHeight = 25; 
doc.setFillColor(255, 255, 255); // header fill color
doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

// Logo and Clinic Info
const logoHeight = 50;       // requested height
const logoWidth = 90;        // keep square (adjust if not)
const logoY = (headerHeight - logoHeight) / 2; // center vertically in header

doc.addImage("/white.png", "PNG", 60, logoY, logoWidth, logoHeight);


    
  // --- INVOICE Title ---
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
    doc.text("INVOICE", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

    // --- Invoice Details ---
    doc.setFontSize(10);
    const detailsY = 45;
    
    // Patient Info
    doc.text(`Patient: ${invoiceData.to}`, 10, detailsY);
    
    // Invoice Number and Date (right aligned)
    doc.text(`Invoice No: ${invoiceData.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, detailsY, { align: "right" });
    doc.text(`Date: ${invoiceData.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 7, { align: "right" });

    // --- Table Section ---
    let currentY = 60;
    
    // Table Header
    doc.setDrawColor(0);
    doc.setFillColor(230, 230, 230);  // Table Header color code
    doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("DESCRIPTION", 12, currentY + 6);
    doc.text("AMOUNT (Rs.)", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
    
    currentY += 12;

// --- Frame ---
if (invoiceData.frame) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Frame:", 12, currentY); // Label
  doc.setFont("helvetica", "normal");
  doc.text(invoiceData.frame, 35, currentY); // User input right after label
  currentY += 8; // move down
}

// --- Lens ---
if (invoiceData.lens) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Lens:", 12, currentY); // Label
  doc.setFont("helvetica", "normal");
  doc.text(invoiceData.lens, 35, currentY); // User input right after label
  currentY += 8; // move down
}

// --- Description ---
// if (invoiceData.description) {
//   const descriptionLines = doc.splitTextToSize(invoiceData.description, doc.internal.pageSize.getWidth() - 50);
//   descriptionLines.forEach(line => {
//     doc.text(line, 12, currentY); // aligned with frame/lens
//     currentY += 6; // line spacing
//   });
// }


//     // Description with automatic line breaks

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);
    


    // Amount aligned to the right
    doc.text(`Rs. ${invoiceData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, 72, { align: "right" });

    // Deduction and Total
    currentY = Math.max(currentY, 85); // Ensure minimum space
    
    // Deduction
    doc.text("Advance Payment", 12, currentY);
    doc.text(`Rs. ${invoiceData.deductAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });
    
    // Total
    currentY += 10;
    doc.setFont("helvetica", "bold");
    doc.text("BALANCE PAYABLE", 12, currentY);
    doc.text(`Rs. ${invoiceData.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });

    // Horizontal line above footer
    doc.line(10, currentY + 5, doc.internal.pageSize.getWidth() - 10, currentY + 5);





// --- Footer Info ---
const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();

doc.setTextColor(0, 0, 0);

// Title
doc.setFont("helvetica", "bold");
doc.setFontSize(12);
doc.text("Ranathunga Optical", pageWidth / 2, pageHeight - 30, { align: "center" });

// Address
doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text("No. 80/A, Kurunegala road, Dambulla", pageWidth / 2, pageHeight - 24, { align: "center" });

// Phone
doc.text("Tel: 071 249 5447 / 066 228 3331", pageWidth / 2, pageHeight - 18, { align: "center" });

// Phone
doc.text("Member of Ophthalmic Opticians Organization Sri Lanka   |   Member of Eye Care Sri Lanka", pageWidth / 2, pageHeight - 12, { align: "center" });





    // --- Footer ---
    doc.setFillColor(0, 0, 0); // Orange
    doc.rect(0, doc.internal.pageSize.getHeight() - 10, doc.internal.pageSize.getWidth(), 10, "F");
    doc.setFontSize(8);
    doc.setTextColor(255, 255, 255);
    doc.text("All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories",
             doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 5, 
             { align: "center" });

    // Save PDF
doc.save(`Invoice_${newInvoiceNumber}.pdf`);

    // Reset form (but DON'T reset invoice number manually)
    setTo("");
    setPatientPhoneNo("");
    setPaymentMethod("cash");
    setDate("");
    setFrame("");
    setLens("");
    setAddPower("");
    // setDescription("");
    setRightLens("");
    setLeftLens("");
    setAmount("");
    setTotalAmount("");
    setDeductAmount(0);

  } catch (error) {
    console.error("Error creating invoice: ", error);
    window.alert("Failed to create invoice. Please try again.");
  }
};






  
// View invoices
// Filters
const [statusFilter, setStatusFilter] = useState("");
const [monthFilter, setMonthFilter] = useState("");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");



const [invoices, setInvoices] = useState([]); // State to store invoices


const handleDownload = () => {
  if (invoices.length === 0) {
    alert("No invoices to download.");
    return;
  }

  // Define the column order you want
  const headers = [
    "invoiceNo",
    "patientPhoneNo",
    "to",
    "date",
    "brand",
    "right Lens",
    "left Lens",
    "add Power",
    "pd",
    "seg",
    "paymentMethod",
    "amount",
    "deductAmount",
    "totalAmount",
    "status",
    "frame",
    "lens"
  ];

  // Format invoices before exporting
  const formattedInvoices = invoices.map((inv) => {
    return {
      invoiceNo: inv.invoiceNo || "",
      patientPhoneNo: inv.patientPhoneNo || "",
      to: inv.to || "",
      date: inv.date || "",
      description: inv.description || "",
      brand: inv.brand || "",
      rightLens: inv.rightLens || "",
      leftLens: inv.leftLens || "",
      addPower: inv.addPower || "", 
      pd: inv.pd || "",
      seg: inv.seg || "",
      paymentMethod: inv.paymentMethod || "",
      amount: Number(inv.amount) || 0,
      deductAmount: Number(inv.deductAmount) || 0,
      totalAmount: Number(inv.totalAmount) || 0,

      status: inv.status || "",
      frame: inv.frame || "",
      lens: inv.lens || ""
    };
  });

  // Convert to worksheet (with headers in right order)
  const worksheet = XLSX.utils.json_to_sheet(formattedInvoices, { header: headers });

  // Set column headers explicitly
  XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

  // Create workbook and append
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  // Trigger download
  XLSX.writeFile(workbook, "invoices.xlsx");
};







// Add these state variables at the top with your other states
const [filteredInvoices, setFilteredInvoices] = useState([]);

// Update the useEffect to include filtering
useEffect(() => {
  const fetchInvoices = async () => {
    try {
      const invoicesCollection = collection(db, "invoices");
      const invoiceSnapshot = await getDocs(invoicesCollection);
      const invoiceList = invoiceSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      setInvoices(invoiceList);
      setFilteredInvoices(invoiceList); // Initialize filtered invoices
    } catch (error) {
      console.error("Error fetching invoices: ", error);
    }
  };

  fetchInvoices();
}, []);


useEffect(() => {
  let data = invoices;

  // Search filter
  if (searchTerm.trim() !== "") {
    data = data.filter((invoice) =>
      invoice.to.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.invoiceNo.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // Status filter
  if (statusFilter !== "") {
    data = data.filter((invoice) => (invoice.status || "") === statusFilter);
  }

  // Month filter (date must be YYYY-MM-DD format)
  if (monthFilter !== "") {
    data = data.filter((invoice) => {
      if (!invoice.date) return false;
      const month = invoice.date.split("-")[1];
      return month === monthFilter;
    });
  }

  // Date range filter
  // if (startDate !== "") {
  //   data = data.filter((inv) => inv.date >= startDate);
  // }

  // if (endDate !== "") {
  //   data = data.filter((inv) => inv.date <= endDate);
  // }

  // Date range filter (SAFE)
if (startDate !== "" || endDate !== "") {
  data = data.filter((inv) => {
    if (!inv.date) return false;

    // Convert invoice date to JS Date
    const invoiceDate = new Date(inv.date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (start && invoiceDate < start) return false;
    if (end && invoiceDate > end) return false;

    return true;
  });
}

  setFilteredInvoices(data);
}, [searchTerm, statusFilter, monthFilter, startDate, endDate, invoices]);









// Add this function to delete an invoice
const handleDeleteInvoice = async (invoiceId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this invoice?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "invoices", invoiceId));
    
    // Update both invoices and filteredInvoices state
    setInvoices(invoices.filter(invoice => invoice.id !== invoiceId));
    setFilteredInvoices(filteredInvoices.filter(invoice => invoice.id !== invoiceId));
    
    alert("Invoice deleted successfully!");
  } catch (error) {
    console.error("Error deleting invoice: ", error);
    alert("Failed to delete invoice.");
  }
};



















// Add this function to generate PDF for individual invoices
const generatePDF = (invoiceData) => {
  // Create PDF with A5 landscape size
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [210, 148], // A5 landscape
  });

  // --- Professional Font Setup ---
  doc.setFont("helvetica", "normal");
  
// --- Header ---
const headerHeight = 25; 
doc.setFillColor(255, 255, 255); // header fill color
doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

// Logo and Clinic Info
const logoHeight = 50;       // requested height
const logoWidth = 90;        // keep square (adjust if not)
const logoY = (headerHeight - logoHeight) / 2; // center vertically in header

doc.addImage("/white.png", "PNG", 60, logoY, logoWidth, logoHeight);








  // --- INVOICE Title ---
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
    doc.text("INVOICE", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

    // --- Invoice Details ---
    doc.setFontSize(10);
    const detailsY = 45;
    
    // Patient Info
    doc.text(`Patient: ${invoiceData.to}`, 10, detailsY);
    
    // Invoice Number and Date (right aligned)
    doc.text(`Invoice No: ${invoiceData.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, detailsY, { align: "right" });
    doc.text(`Date: ${invoiceData.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 7, { align: "right" });

    // --- Table Section ---
    let currentY = 60;
    
    // Table Header
    doc.setDrawColor(0);
    doc.setFillColor(230, 230, 230);  // Table Header color code
    doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("DESCRIPTION", 12, currentY + 6);
    doc.text("AMOUNT (Rs.)", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
    
    currentY += 12;

// --- Frame ---
if (invoiceData.frame) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Frame:", 12, currentY); // Label
  doc.setFont("helvetica", "normal");
  doc.text(invoiceData.frame, 35, currentY); // User input right after label
  currentY += 8; // move down
}

// --- Lens ---
if (invoiceData.lens) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Lens:", 12, currentY); // Label
  doc.setFont("helvetica", "normal");
  doc.text(invoiceData.lens, 35, currentY); // User input right after label
  currentY += 8; // move down
}

// --- Description ---
if (invoiceData.description) {
  const descriptionLines = doc.splitTextToSize(invoiceData.description, doc.internal.pageSize.getWidth() - 50);
  descriptionLines.forEach(line => {
    doc.text(line, 12, currentY); // aligned with frame/lens
    currentY += 6; // line spacing
  });
}


    // Description with automatic line breaks

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    


    // Amount aligned to the right
    doc.text(`Rs. ${invoiceData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, 72, { align: "right" });

    // Deduction and Total
    currentY = Math.max(currentY, 85); // Ensure minimum space
    
    // Deduction
    doc.text("Advance Payment", 12, currentY);
    doc.text(`Rs. ${invoiceData.deductAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });
    
    // Total
    currentY += 10;
    doc.setFont("helvetica", "bold");
    doc.text("BALANCE PAYABLE", 12, currentY);
    doc.text(`Rs. ${invoiceData.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });

    // Horizontal line above footer
    doc.line(10, currentY + 5, doc.internal.pageSize.getWidth() - 10, currentY + 5);





// --- Footer Info ---
const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();

doc.setTextColor(0, 0, 0);

// Title
doc.setFont("helvetica", "bold");
doc.setFontSize(12);
doc.text("Ranathunga Optical", pageWidth / 2, pageHeight - 30, { align: "center" });

// Address
doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text("No. 80/A, Kurunegala road, Dambulla", pageWidth / 2, pageHeight - 24, { align: "center" });

// Phone
doc.text("Tel: 071 249 5447 / 066 228 3331", pageWidth / 2, pageHeight - 18, { align: "center" });

// Phone
doc.text("Member of Ophthalmic Opticians Organization Sri Lanka   |   Member of Eye Care Sri Lanka", pageWidth / 2, pageHeight - 12, { align: "center" });





    // --- Footer ---
    doc.setFillColor(0, 0, 0); // Orange
    doc.rect(0, doc.internal.pageSize.getHeight() - 10, doc.internal.pageSize.getWidth(), 10, "F");
    doc.setFontSize(8);
    doc.setTextColor(255, 255, 255);
    doc.text("All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories",
           doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 5, 
           { align: "center" });

  // Save PDF
  doc.save(`Invoice_${invoiceData.invoiceNo}.pdf`);
};










  // Handle Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };
  

  // Example: Fetch user details (you might want to update this based on your logic)
  useEffect(() => {
    // Logic to fetch user details from Firestore or Firebase Auth
    const fetchUserDetails = async () => {
      const user = auth.currentUser;
      if (user) {
        // If the user is logged in, set userDetails (you can fetch more details from Firestore if needed)
        setUserDetails({
          name: user.displayName,
          email: user.email,
        });
      }
    };

    fetchUserDetails();
  }, [auth]);






// //create consultation invoive

// // Create consultation invoice
// const handleCreateConsultationInvoice = async () => {
//   if (!to || !date || !description || !amount || !invoiceNumber) {
//     window.alert("Please fill in all required fields before proceeding!");
//     return;
//   }

//   const totalAmount = parseFloat(amount) - parseFloat(deductAmount);

//   const consultationData = {
//     patientName: String(to).trim(),
//     date: String(date).trim(),
//     description: String(description).trim(),
//     amount: parseFloat(amount) || 0,
//     totalAmount: totalAmount || 0,
//     invoiceNo: invoiceNumber,
//     type: "consultation", // Add type to distinguish
//     createdAt: new Date(),
//   };

//   try {
//     // Save to "consultation" collection in Firestore
//     await addDoc(collection(db, "consultation"), consultationData);

//     // Create PDF with A5 landscape size
//     const doc = new jsPDF({
//       orientation: "landscape",
//       unit: "mm",
//       format: [210, 148], // A5 landscape
//     });

//     // --- Professional Font Setup ---
//     doc.setFont("helvetica", "normal");
    
//     // --- Header ---
//   doc.setFillColor(255, 140, 0); // header fill color
//   doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
  
//   // Logo and Clinic Info
// const headerHeight = 25;
// const logoHeight = 20;
// const logoY = (headerHeight - logoHeight) / 2; // vertical center

// doc.addImage("/round-logo.png", "PNG", 10, logoY, 20, logoHeight);

//     doc.setFontSize(14);
//     doc.setTextColor(255, 255, 255);
//     doc.setFont("helvetica", "bold");
//     doc.text("Ranathunga Optical", 35, 12);
//     doc.setFontSize(9);
//     doc.text("No. 80/A, Kurunegala road, Dambulla", 35, 17);
//     doc.text("Tel: 071 249 5447", 35, 22);

//     // --- CONSULTATION INVOICE Title ---
//     doc.setFontSize(16);
//     doc.setTextColor(0, 0, 0);
//     doc.text("CONSULTATION INVOICE", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

//     // --- Invoice Details ---
//     doc.setFontSize(10);
//     const detailsY = 45;
    
//     // Patient Info
//     doc.text(`Patient: ${consultationData.patientName}`, 10, detailsY);
    
//     // Invoice Number and Date (right aligned)
//     doc.text(`Invoice No: ${consultationData.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, detailsY, { align: "right" });
//     doc.text(`Date: ${consultationData.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 7, { align: "right" });

//     // --- Table Section ---
//     let currentY = 60;
    
//     // Table Header
//     doc.setDrawColor(0);
//     doc.setFillColor(230, 230, 230);
//     doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(10);
//     doc.text("DESCRIPTION", 12, currentY + 6);
//     doc.text("AMOUNT (Rs.)", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
    
//     currentY += 12;

//     // Description with automatic line breaks
//     const descriptionLines = doc.splitTextToSize(consultationData.description, doc.internal.pageSize.getWidth() - 50);
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);
    
//     // Print each line of description
//     descriptionLines.forEach(line => {
//       doc.text(line, 12, currentY);
//       currentY += 5; // Line spacing
//     });

//     // Amount aligned to the right
//     doc.text(`Rs. ${consultationData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, 72, { align: "right" });

//     // Deduction and Total
//     currentY = Math.max(currentY, 85); // Ensure minimum space
    
  
    
//     // Total
//     currentY += 10;
//     doc.setFont("helvetica", "bold");
//     doc.text("Total Amount", 12, currentY);
//     doc.text(`Rs. ${consultationData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });

//     // Horizontal line above footer
//     doc.line(10, currentY + 5, doc.internal.pageSize.getWidth() - 10, currentY + 5);

//     // --- Footer ---
//     doc.setFillColor(0, 0, 0); //footer color
//     doc.rect(0, doc.internal.pageSize.getHeight() - 10, doc.internal.pageSize.getWidth(), 10, "F");
//     doc.setFontSize(8);
//     doc.setTextColor(255, 255, 255);
//     doc.text("All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories", 
//              doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 5, 
//              { align: "center" });

//     // Save PDF
//     doc.save(`Consultation_Invoice_${invoiceNumber}.pdf`);

//     // Reset form
//     setInvoiceNumber("");
//     setTo("");
//     setDate("");
//     setDescription("");
//     setAmount("");
//     setDeductAmount(0);
    
//   } catch (error) {
//     console.error("Error creating consultation invoice: ", error);
//     window.alert("Failed to create consultation invoice. Please try again.");
//   }
// };




  







// //fetch all previous consultation invoices


// const [consultationInvoices, setConsultationInvoices] = useState([]);
// const [selectedInvoice, setSelectedInvoice] = useState(null);

// // Fetch consultation invoices from Firestore
// useEffect(() => {
//   const fetchConsultationInvoices = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "consultation"));
//       const invoices = [];
//       querySnapshot.forEach((doc) => {
//         invoices.push({ id: doc.id, ...doc.data() });
//       });
//       setConsultationInvoices(invoices);
//     } catch (error) {
//       console.error("Error fetching consultation invoices: ", error);
//     }
//   };

//   fetchConsultationInvoices();
// }, []);

// const handleViewInvoice = (invoice) => {
//   setSelectedInvoice(invoice);
// };








/////////////////////////////  Create Eye Examination Report ///////////////////////////////////////////////////////////////////////////////////////////////

  // Patient Information
  const [patientName, setPatientName] = useState('');
  const [examDate, setExamDate] = useState('');
  const [patientId, setPatientId] = useState('');
  const [dob, setDob] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [email, setEmail] = useState('');
  const [fundi, setFundi] = useState('');

  // History Taking
  const [chiefComplaint, setChiefComplaint] = useState('');
  const [hpc, setHpc] = useState('');
  const [pastOcularHistory, setPastOcularHistory] = useState('');
  const [medicalHistory, setMedicalHistory] = useState('');
  const [familyOcularHistory, setFamilyOcularHistory] = useState('');
  const [socialHistory, setSocialHistory] = useState('');




const [lids, setLids] = useState('');
const [conjunctiva, setConjunctiva] = useState('');
const [cornea, setCornea] = useState('');
const [sclera, setSclera] = useState('');
const [ac, setAc] = useState('');
const [lens, setLens] = useState('');
const [vitreous, setVitreous] = useState('');


// External Examination (Left and Right Eye - separate states)
const [lidsLeft, setLidsLeft] = useState('');
const [lidsRight, setLidsRight] = useState('');

const [conjunctivaLeft, setConjunctivaLeft] = useState('');
const [conjunctivaRight, setConjunctivaRight] = useState('');

const [corneaLeft, setCorneaLeft] = useState('');
const [corneaRight, setCorneaRight] = useState('');

const [scleraLeft, setScleraLeft] = useState('');
const [scleraRight, setScleraRight] = useState('');

const [acLeft, setAcLeft] = useState('');
const [acRight, setAcRight] = useState('');

const [lensLeft, setLensLeft] = useState('');
const [lensRight, setLensRight] = useState('');

const [vitreousLeft, setVitreousLeft] = useState('');
const [vitreousRight, setVitreousRight] = useState('');



  // Family History
  const [familyHistory, setFamilyHistory] = useState({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  // Visual Acuity
  const [visualAcuity, setVisualAcuity] = useState({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });


  //HbRx

  const [hbrx, setHbrx] = useState({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
  });




  // Refraction
  const [refraction, setRefraction] = useState({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',
  });

  // Follow Up
  const [needsFollowUp, setNeedsFollowUp] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');
  const [remarks, setRemarks] = useState('');

  const handleFamilyHistoryChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === 'other') {
      setFamilyHistory({ ...familyHistory, other: value });
    } else {
      setFamilyHistory({ ...familyHistory, [name]: checked });
    }
  };

  const handleVisualAcuityChange = (e) => {
    const { name, value } = e.target;
    setVisualAcuity({ ...visualAcuity, [name]: value });
  };

  const handleHbrxChange = (e) => {
    const { name, value } = e.target;
    setHbrx({ ...hbrx, [name]: value });
  };


  const handleRefractionChange = (e) => {
    const { name, value } = e.target;
    setRefraction({ ...refraction, [name]: value });
  };

  const handleEyeExamSubmit = async (e) => {
    e.preventDefault();

    if (!patientName || !examDate) {
      alert('Please fill in patient name and date');
      return;
    }

    const eyeExamData = {
      patientInfo: {
        name: patientName,
        date: examDate,
        id: patientId,
        dob: dob,
        age,
        gender,
        contactNo,
        email,
        fundi,
      },
      history: {
        chiefComplaint,
        hpc,
        pastOcularHistory,
        medicalHistory,
        familyOcularHistory,
        socialHistory,
      },

      externalExam: {
        lids,
        conjunctiva,
        cornea,
        sclera,
        ac,
        lens,
        vitreous,
      },


      familyHistory,
      visualAcuity,
      hbrx,
      refraction,
      followUp: {
        needed: needsFollowUp,
        date: followUpDate,
        remarks,
      },
      createdAt: new Date(),
    };

    try {
      // Save to Firestore
      await addDoc(collection(db, 'eyeExams'), eyeExamData);
      
      // Generate PDF
      generateEyeExamPDF(eyeExamData);
      
    // Reset form after everything is done
    resetForm();

      alert('Eye exam report saved successfully!');
    } catch (error) {
      console.error('Error saving eye exam: ', error);
      alert('Failed to save eye exam');
    }
  };


const resetForm = () => {
  setPatientName('');
  setExamDate('');
  setPatientId('');
  setDob('');
  setAge('');
  setGender('');
  setContactNo('');
  setEmail('');
  setFundi('');

  setChiefComplaint('');
  setHpc('');
  setPastOcularHistory('');
  setMedicalHistory('');
  setFamilyOcularHistory('');
  setSocialHistory('');

  setLids('');
  setConjunctiva('');
  setCornea('');
  setSclera('');
  setAc('');
  setLens('');
  setVitreous('');

  setLidsLeft('');
  setLidsRight('');
  setConjunctivaLeft('');
  setConjunctivaRight('');
  setCorneaLeft('');
  setCorneaRight('');
  setScleraLeft('');
  setScleraRight('');
  setAcLeft('');
  setAcRight('');
  setLensLeft('');
  setLensRight('');
  setVitreousLeft('');
  setVitreousRight('');

  setFamilyHistory({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  setVisualAcuity({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });

  setHbrx({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
  });

  setRefraction({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',
  });

  setNeedsFollowUp(false);
  setFollowUpDate('');
  setRemarks('');
};





  const generateEyeExamPDF = (data) => {
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text

    // Constants for layout
    const leftMargin = 15;
    const rightMargin = 15;
    const pageWidth = 210 - leftMargin - rightMargin;
    const column1 = leftMargin;
    const column2 = 100;
    const columnWidth = 80;

    // Header Section
    doc.addImage('/white.png', 'PNG', leftMargin, 2, 40, 40); // Larger logo
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ranathunga Optical', leftMargin + 55, 18);
    doc.setFontSize(10);
    doc.text('No. 80/A, Kurunegala road, Dambulla', leftMargin + 55, 23);
    doc.text('Tel: 071 249 5447', leftMargin + 55, 28);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 18, { align: 'right' });
    doc.line(leftMargin, 32, 210 - rightMargin, 32); // Horizontal line

    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    // doc.text(`Patient ID: ${data.patientInfo.id || '-'}`, column1, 62);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 62);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 68);
    
    // Column 2
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 56);
    // doc.text(`Email: ${data.patientInfo.email || '-'}`, column2, 62);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 62);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

// History Sections (inline, label + value)
doc.setFontSize(10);
doc.setFont('helvetica', 'normal');

doc.text(`Chief Complaint : ${data.history.chiefComplaint || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`History Of Present Complaint : ${data.history.hpc || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Past Ocular History : ${data.history.pastOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Medical History : ${data.history.medicalHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Family Ocular History : ${data.history.familyOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Social History : ${data.history.socialHistory || '-'}`, leftMargin, yPos);
yPos += 10; // small gap after history section

    // Check for page break
    if (yPos > 250) {
        doc.addPage();
        yPos = 20;
    }

 // External Examination Table
yPos = addExamTable('External Examination', [
  { structure: 'Lids', left: lidsLeft || '-', right: lidsRight || '-' },
  { structure: 'Conjunctiva', left: conjunctivaLeft || '-', right: conjunctivaRight || '-' },
  { structure: 'Cornea', left: corneaLeft || '-', right: corneaRight || '-' },
  { structure: 'Sclera', left: scleraLeft || '-', right: scleraRight || '-' },
  { structure: 'A/C', left: acLeft || '-', right: acRight || '-' },
  { structure: 'Lens', left: lensLeft || '-', right: lensRight || '-' },
  { structure: 'Vitreous', left: vitreousLeft || '-', right: vitreousRight || '-' }
], yPos, [
  { label: 'Structure', key: 'structure' },
  { label: 'Left Eye', key: 'left' },
  { label: 'Right Eye', key: 'right' }
]);





    // Family History
    yPos = addSection('Family History', 
        `POAG: ${data.familyHistory.poag ? 'Yes' : 'No'}, ` +
        `AMD: ${data.familyHistory.amd ? 'Yes' : 'No'}, ` +
        `DM: ${data.familyHistory.dm ? 'Yes' : 'No'}` +
        (data.familyHistory.other ? `, Other: ${data.familyHistory.other}` : ''), 
        yPos);

    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/C', od: data.visualAcuity.od_cg, os: data.visualAcuity.os_cg },
        { test: 'S/C', od: data.visualAcuity.od_sg, os: data.visualAcuity.os_sg },
        { test: 'P/H', od: data.visualAcuity.od_ph, os: data.visualAcuity.os_ph },
        { test: 'PD', od: data.visualAcuity.od_pd, os: data.visualAcuity.os_pd },
       { test: 'SEG', od: data.visualAcuity.seg_va, os: '-' }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);

    // Additional Visual Tests
    // if (data.visualAcuity.ct || data.visualAcuity.npc || data.visualAcuity.om) {
    //     yPos = addSection(' Accessory Tests',
    //         `CT: ${data.visualAcuity.ct || '-'}, ` +
    //         `NPC: ${data.visualAcuity.npc || '-'}, ` +
    //         `OM: ${data.visualAcuity.om || '-'}`, 
    //         yPos,
          
    //       );
          
    // }
// After Visual Acuity + Accessory Tests
if (
  (data.visualAcuity.ct && data.visualAcuity.ct.trim() !== '') ||
  (data.visualAcuity.npc && data.visualAcuity.npc.trim() !== '') ||
  (data.visualAcuity.om && data.visualAcuity.om.trim() !== '')
) {
  yPos = addSection('Accessory Tests',
      `CT: ${data.visualAcuity.ct || '-'}, ` +
      `NPC: ${data.visualAcuity.npc || '-'}, ` +
      `OM: ${data.visualAcuity.om || '-'}`, 
      yPos
  );
}


doc.addPage();
yPos = 20;



      //   // Check for page break
      //   if (yPos > 250) {
      //     doc.addPage();
      //     yPos = 20;
      // }


    // Fundus Examination
    if (data.patientInfo.fundi) {
        yPos = addSection('Fundus Examination', data.patientInfo.fundi, yPos);
    }


      //Hb Rx

      if (data.hbrx) {
       const hbRxData = [
  { eye: 'OD',
    sph: data.hbrx.hb_od_sph,
    cyl: data.hbrx.hb_od_cyl,
    axis: data.hbrx.hb_od_axis,
    vision: data.hbrx.hb_od_vision },
  { eye: 'OS',
    sph: data.hbrx.rx_os_sph,   // ✅ use rx_os_* here
    cyl: data.hbrx.rx_os_cyl,
    axis: data.hbrx.rx_os_axis,
    vision: data.hbrx.rx_os_vision }
];
        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
      }



    // Refraction and Hb Rx
    const refractionData = [
        { eye: 'OD', 
          sph: data.refraction.od_sph, 
          cyl: data.refraction.od_cyl, 
          axis: data.refraction.od_axis, 
          vision: data.refraction.od_vision },
        { eye: 'OS', 
          sph: data.refraction.os_sph, 
          cyl: data.refraction.os_cyl, 
          axis: data.refraction.os_axis, 
          vision: data.refraction.os_vision }
    ];

    yPos = addExamTable('Refraction', refractionData, yPos, [
        { label: 'Eye', key: 'eye' },
        { label: 'Sph', key: 'sph' },
        { label: 'Cyl', key: 'cyl' },
        { label: 'Axis', key: 'axis' },
        { label: 'Vision', key: 'vision' }
    ]);



    // Follow Up
    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp.needed ? 'Yes' : 'No'}` +
        (data.followUp.needed ? `, Date: ${data.followUp.date}` : '') +
        (data.followUp.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories"', 105, 287, { align: 'center' });
    doc.text('© Ranathunga Optical', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};













//fetch all the eye exam report

useEffect(() => {
  const fetchEyeExamRecords = async () => {
    if (selectedOption === "viewEyeExam") {
      try {
        const querySnapshot = await getDocs(collection(db, 'eyeExams'));
        const records = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setEyeExamRecords(records);
      } catch (error) {
        console.error("Error fetching eye exam records: ", error);
      }
    }
  };

  fetchEyeExamRecords();
}, [selectedOption]);






const filteredRecords = eyeExamRecords.filter(record => {
  // Search term filtering
  const matchesSearch = 
    record.patientInfo?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    record.patientInfo?.id?.toLowerCase().includes(searchTerm.toLowerCase());
  
  // Date filtering
  const recordDate = new Date(record.patientInfo?.date);
  const today = new Date();
  
  let matchesDate = true;
  if (filterOption === 'today') {
    matchesDate = recordDate.toDateString() === today.toDateString();
  } else if (filterOption === 'week') {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    matchesDate = recordDate >= weekAgo;
  } else if (filterOption === 'month') {
    const monthAgo = new Date();
    monthAgo.setMonth(monthAgo.getMonth() - 1);
    matchesDate = recordDate >= monthAgo;
  }
  
  return matchesSearch && matchesDate;
});








//patient's eye examination report
const generatePatientEyeExam = (data) => {

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  // Set default font styles
  doc.setFont("helvetica");
  doc.setTextColor(0, 0, 0); // Black text

  // Constants for layout
  const leftMargin = 15;
  const rightMargin = 15;
  const pageWidth = 210 - leftMargin - rightMargin;
  const column1 = leftMargin;
  const column2 = 100;

  // Header Section
  doc.addImage("/white.png", "PNG", leftMargin, 2, 40, 40); // Logo
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Ranathunga Optical", leftMargin + 55, 18);
  doc.setFontSize(10);
  doc.text("No. 80/A, Kurunegala road, Dambulla", leftMargin + 55, 23);
  doc.text("Tel: 071 249 5447", leftMargin + 55, 28);
  doc.text(`Date: ${data.patientInfo.date}`, 180, 18, { align: "right" });
  doc.line(leftMargin, 32, 210 - rightMargin, 32); // Divider

  // Report Title
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("EYE EXAMINATION REPORT", 105, 42, { align: "center" });
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  // Patient Information
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("PATIENT INFORMATION", leftMargin, 50);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  // Column 1
  doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
  doc.text(`Age: ${data.patientInfo.age || "-"}`, column1, 62);
  doc.text(`Gender: ${data.patientInfo.gender || "-"}`, column1, 68);

  // Column 2
  doc.text(`Contact: ${data.patientInfo.contactNo || "-"}`, column2, 56);
  doc.text(`DOB: ${data.patientInfo.dob || "-"}`, column2, 62);
  doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider

  // Helper functions
  const addSection = (title, content, y, maxWidth = pageWidth) => {
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(title.toUpperCase(), leftMargin, y);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    const lines = doc.splitTextToSize(content || "-", maxWidth);
    doc.text(lines, leftMargin + 5, y + 6);
    return y + lines.length * 5 + 10;
  };

  const addExamTable = (title, data, y, columns) => {
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(title.toUpperCase(), leftMargin, y);
    y += 6;

    // Table header
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    columns.forEach((col, i) => {
      doc.text(col.label, leftMargin + i * 40, y);
    });
    y += 6;

    // Table data
    doc.setFont("helvetica", "normal");
    data.forEach((row) => {
      columns.forEach((col, i) => {
        doc.text(row[col.key] || "-", leftMargin + i * 40, y);
      });
      y += 6;
    });

    return y + 6;
  };

  let yPos = 82;

  // History Sections
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Chief Complaint : ${data.history.chiefComplaint || "-"}`, leftMargin, yPos);
  yPos += 6;
  doc.text(`History Of Present Complaint : ${data.history.hpc || "-"}`, leftMargin, yPos);
  yPos += 6;
  doc.text(`Past Ocular History : ${data.history.pastOcularHistory || "-"}`, leftMargin, yPos);
  yPos += 6;
  doc.text(`Medical History : ${data.history.medicalHistory || "-"}`, leftMargin, yPos);
  yPos += 6;
  doc.text(`Family Ocular History : ${data.history.familyOcularHistory || "-"}`, leftMargin, yPos);
  yPos += 6;
  doc.text(`Social History : ${data.history.socialHistory || "-"}`, leftMargin, yPos);
  yPos += 10;

  // External Examination Table
  yPos = addExamTable(
    "External Examination",
    [
      { structure: "Lids", left: data.external?.lidsLeft || "-", right: data.external?.lidsRight || "-" },
      { structure: "Conjunctiva", left: data.external?.conjunctivaLeft || "-", right: data.external?.conjunctivaRight || "-" },
      { structure: "Cornea", left: data.external?.corneaLeft || "-", right: data.external?.corneaRight || "-" },
      { structure: "Sclera", left: data.external?.scleraLeft || "-", right: data.external?.scleraRight || "-" },
      { structure: "A/C", left: data.external?.acLeft || "-", right: data.external?.acRight || "-" },
      { structure: "Lens", left: data.external?.lensLeft || "-", right: data.external?.lensRight || "-" },
      { structure: "Vitreous", left: data.external?.vitreousLeft || "-", right: data.external?.vitreousRight || "-" },
    ],
    yPos,
    [
      { label: "Structure", key: "structure" },
      { label: "Left Eye", key: "left" },
      { label: "Right Eye", key: "right" },
    ]
  );

  // Family History
  yPos = addSection(
    "Family History",
    `POAG: ${data.familyHistory.poag ? "Yes" : "No"}, ` +
      `AMD: ${data.familyHistory.amd ? "Yes" : "No"}, ` +
      `DM: ${data.familyHistory.dm ? "Yes" : "No"}` +
      (data.familyHistory.other ? `, Other: ${data.familyHistory.other}` : ""),
    yPos
  );

  // Visual Acuity
  yPos = addExamTable(
    "Visual Acuity",
    [
      { test: "C/C", od: data.visualAcuity.od_cg, os: data.visualAcuity.os_cg },
      { test: "S/C", od: data.visualAcuity.od_sg, os: data.visualAcuity.os_sg },
      { test: "P/H", od: data.visualAcuity.od_ph, os: data.visualAcuity.os_ph },
      { test: "PD", od: data.visualAcuity.od_pd, os: data.visualAcuity.os_pd },
      { test: "SEG", od: data.visualAcuity.seg_va, os: "-" },
    ],
    yPos,
    [
      { label: "Test", key: "test" },
      { label: "OD", key: "od" },
      { label: "OS", key: "os" },
    ]
  );

  // Accessory Tests
  if (
    (data.visualAcuity.ct && data.visualAcuity.ct.trim() !== "") ||
    (data.visualAcuity.npc && data.visualAcuity.npc.trim() !== "") ||
    (data.visualAcuity.om && data.visualAcuity.om.trim() !== "")
  ) {
    yPos = addSection(
      "Accessory Tests",
      `CT: ${data.visualAcuity.ct || "-"}, ` +
        `NPC: ${data.visualAcuity.npc || "-"}, ` +
        `OM: ${data.visualAcuity.om || "-"}`,
      yPos
    );
  }

  // Fundus Examination
  if (data.patientInfo.fundi) {
    yPos = addSection("Fundus Examination", data.patientInfo.fundi, yPos);
  }

  // Follow Up
  yPos = addSection(
    "Follow Up",
    `Needed: ${data.followUp.needed ? "Yes" : "No"}` +
      (data.followUp.needed ? `, Date: ${data.followUp.date}` : "") +
      (data.followUp.remarks ? `\nRemarks: ${data.followUp.remarks}` : ""),
    yPos
  );

  // Footer
  doc.setFontSize(8);
  doc.setTextColor(100);
  doc.text(
    '"All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories"',
    105,
    290,
    { align: "center" }
  );
  doc.text("© Ranathunga Optical", 105, 295, { align: "center" });

  // Save PDF
  doc.save(
    `EyeExam_${data.patientInfo.name.replace(/\s+/g, "_")}_${data.patientInfo.date.replace(/\//g, "-")}.pdf`
  );
};














  const [notifications, setNotifications] = useState([]);
  const [todayCount, setTodayCount] = useState(0);
  const [error, setError] = useState(null);

  // Helper function to convert date to readable format
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  // Helper function to check if date is today
  const isToday = (date) => {
    if (!date) return false;
    const d = new Date(date);
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
  };

  // Helper function to get days difference
  const getDaysDifference = (date) => {
    if (!date) return 0;
    const d = new Date(date);
    const today = new Date();
    const diffTime = d - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  useEffect(() => {
    const fetchFollowUpDates = async () => {
      try {
        const patientsRef = collection(db, 'patients');
        const q = query(
          patientsRef,
          where("followUpDate", "!=", null),
          orderBy("followUpDate", "asc")
        );
        
        const querySnapshot = await getDocs(q);
        const fetchedNotifications = [];
        let todayNotifications = 0;

        querySnapshot.forEach((doc) => {
          const patientData = doc.data();
          const followUpDate = patientData.followUpDate;
          
          // Convert Firestore Timestamp to Date if needed
          const dateValue = followUpDate.toDate ? followUpDate.toDate() : new Date(followUpDate);
          
const notification = {
  ...patientData,
  id: doc.id,
  patientName: patientData.name || 'Unknown Patient',
  followUpDate: dateValue, // this now overwrites any raw version from Firestore
  formattedDate: formatDate(dateValue),
  isToday: isToday(dateValue),
  daysDifference: getDaysDifference(dateValue),
  status: patientData.status || 'pending',
};

          
          // Only show future or today's notifications
          if (notification.daysDifference >= 0) {
            fetchedNotifications.push(notification);
            if (notification.isToday) todayNotifications++;
          }
        });

        setNotifications(fetchedNotifications);
        setTodayCount(todayNotifications);
      } catch (err) {
        console.error("Error fetching notifications:", err);
        setError("Failed to load notifications. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchFollowUpDates();
  }, []);

  const getPriorityColor = (date) => {
    if (!date) return '#52c41a';
    const today = new Date();
    const diffInDays = getDaysDifference(date);
    
    if (isToday(date)) return '#ff4d4f'; // Red for today
    if (diffInDays <= 3) return '#faad14'; // Yellow for upcoming 3 days
    return '#52c41a'; // Green for future dates
  };


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  

const handleStatusChange = async (invoiceId, newStatus) => {
  try {
    const invoiceRef = doc(db, "invoices", invoiceId);
    await updateDoc(invoiceRef, { status: newStatus });
    // Update local state too
    setInvoices((prev) =>
      prev.map((inv) =>
        inv.id === invoiceId ? { ...inv, status: newStatus } : inv
      )
    );
  } catch (err) {
    console.error("Error updating status:", err);
  }
};



/////////////////////////////////////////////////////  sales report  ///////////////////////////////////////////////////////////
  const [filterMode, setFilterMode] = useState("daily"); // daily | monthly | yearly
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const [totalSale, setTotalSale] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalPayable, setTotalPayable] = useState(0);

  // ✅ Fetch invoices
  const fetchInvoices = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "invoices"));
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setInvoices(list);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  }, []);

  useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);

  // ✅ Filter logic
  const filteredInvoicesInSale = invoices.filter((inv) => {
    const invDate = dayjs(inv.date);
    if (filterMode === "daily") {
      return invDate.isSame(selectedDate, "day");
    } else if (filterMode === "monthly") {
      return (
        invDate.month() === selectedDate.month() &&
        invDate.year() === selectedDate.year()
      );
    } else if (filterMode === "yearly") {
      return invDate.year() === selectedDate.year();
    }
    return true;
  });

  // ✅ Calculate summaries
  useEffect(() => {
    const totalS = filteredInvoicesInSale.reduce((acc, curr) => acc + (curr.amount || 0), 0);
    const totalP = filteredInvoicesInSale.reduce((acc, curr) => acc + (curr.deductAmount || 0), 0);
    const totalBal = filteredInvoicesInSale.reduce(
      (acc, curr) => acc + ((curr.amount || 0) - (curr.deductAmount || 0)),
      0
    );

    setTotalSale(totalS);
    setTotalPaid(totalP);
    setTotalPayable(totalBal);
  }, [filteredInvoicesInSale]);






//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


const searchInvoice = async () => {
  try {
    const q = query(
      collection(db, "invoices"),
      where("invoiceNo", "==", searchInvoiceNo)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      window.alert("Invoice not found!");
      setFoundInvoice(null);
      return;
    }

    const data = snap.docs[0].data();
    setFoundInvoice({ id: snap.docs[0].id, ...data });

    // Remaining balance
    const balance = parseFloat(data.totalAmount);
    setBalanceAfterSettle(balance);

  } catch (e) {
    console.error(e);
  }
};



const handleSettlePayment = async () => {
  if (!foundInvoice) {
    alert("Search invoice first!");
    return;
  }

  const balance = parseFloat(foundInvoice.totalAmount);
  const paidNow = parseFloat(settleAmount);

  if (paidNow <= 0 || paidNow > balance) {
    alert("Invalid settle amount.");
    return;
  }

  const newBalance = balance - paidNow;

  try {
    // 1️⃣ Create settlement record
    await addDoc(collection(db, "settlements"), {
      invoiceNo: foundInvoice.invoiceNo,
      paidAmount: paidNow,
      previousBalance: balance,
      newBalance: newBalance,
      date: new Date(),
    });

    // 2️⃣ Update original invoice
    await updateDoc(doc(db, "invoices", foundInvoice.id), {
      totalAmount: newBalance,
    });

    // 3️⃣ Generate PDF
    createSettlementPDF(foundInvoice, paidNow, newBalance);

    alert("Settlement completed!");
    setFoundInvoice(null);
    setSearchInvoiceNo("");
    setSettleAmount("");

  } catch (e) {
    console.error(e);
    alert("Failed to settle!");
  }
};




const createSettlementPDF = (invoice, paidNow, newBalance) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a5",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  /* -------------------- HEADER -------------------- */
  const headerHeight = 25;
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, headerHeight, "F");

  // LOGO
  const logoWidth = 65;
  const logoHeight = 40;
  doc.addImage(
    "/white.png",
    "PNG",
    pageWidth / 2 - logoWidth / 2,
    3,
    logoWidth,
    logoHeight
  );

  /* -------------------- TITLE -------------------- */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("SETTLEMENT BILL", pageWidth / 2, headerHeight + 10, {
    align: "center",
  });

  /* -------------------- BASIC DETAILS -------------------- */
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);

  let y = headerHeight + 22;

  doc.text(`Invoice No: ${invoice.invoiceNo}`, 10, y);
  y += 7;

  doc.text(`Patient: ${invoice.to}`, 10, y);
  y += 7;

  doc.text(`Date: ${new Date().toLocaleDateString()}`, 10, y);
  y += 12;

  /* -------------------- PAYMENT DETAILS -------------------- */
  const rightX = pageWidth - 70;

  doc.setFont("helvetica", "bold");
  doc.text("Advance / Previous Balance:", 10, y);
  doc.text(`Rs. ${invoice.totalAmount.toFixed(2)}`, rightX, y);

  y += 10;

  doc.text("Amount Paid Now:", 10, y);
  doc.text(`Rs. ${paidNow.toFixed(2)}`, rightX, y);

  y += 10;

  doc.text("Remaining Balance:", 10, y);
  doc.text(`Rs. ${newBalance.toFixed(2)}`, rightX, y);

  /* -------------------- FOOTER DETAILS -------------------- */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Ranathunga Optical", pageWidth / 2, pageHeight - 30, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(
    "No. 80/A, Kurunegala road, Dambulla",
    pageWidth / 2,
    pageHeight - 24,
    { align: "center" }
  );

  doc.text(
    "Tel: 071 249 5447 / 066 228 3331",
    pageWidth / 2,
    pageHeight - 18,
    { align: "center" }
  );

  doc.text(
    "Member of Ophthalmic Opticians Organization Sri Lanka | Member of Eye Care Sri Lanka",
    pageWidth / 2,
    pageHeight - 12,
    { align: "center" }
  );

  /* -------------------- BLACK FOOTER STRIP -------------------- */
  doc.setFillColor(0, 0, 0);
  doc.rect(0, pageHeight - 10, pageWidth, 10, "F");

  doc.setFontSize(8);
  doc.setTextColor(255, 255, 255);
  doc.text(
    "All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories",
    pageWidth / 2,
    pageHeight - 4,
    { align: "center" }
  );

  /* -------------------- SAVE PDF -------------------- */
  doc.save(`Settlement_${invoice.invoiceNo}.pdf`);
};












return (


    <div className="hero-dashboard-container">
      {/* Left Sidebar */}
      <div className="lecturer-sidebar">
      <div className="home-content">
              <img
                src="/logo.png" // Assuming the image is in the public folder
                alt="Ranathunga Optical"
              
              />
              </div>
        <h2 className="lecturer-sidebar-title">Ranathunga Optical</h2>

        <div className="lecturer-sidebar-list">
        <li onClick={() => setSelectedOption("addPatient")}>Add Patient</li>
        <li onClick={() => setSelectedOption("viewPatients")}>View All Patients</li>
          <li onClick={() => setSelectedOption("createInvoice")}>Create Invoice</li>
          <li onClick={() => setSelectedOption("settleInvoice")}>Create Settle Invoice</li>

          <li onClick={() => setSelectedOption("viewInvoice")}>View Previous Invoice</li>
          {/* <li onClick={() => setSelectedOption("consultation")}>Create Consultation Invoice</li>
          <li onClick={() => setSelectedOption("previousConsultation")}>View Previous Consultation</li> */}
          <li onClick={() => setSelectedOption("eyeExam")}>Create Eye Exam Report</li>
          <li onClick={() => setSelectedOption("viewEyeExam")}>View All Eye Exam Report</li>
          <li onClick={() => setSelectedOption("patienteyeExam")}>Eye Exam Report For Patient</li>
          <li onClick={() => setSelectedOption("notification")}>Patient Follow-Ups</li>
           <li onClick={() => setSelectedOption("salesReport")}>Sales Report</li>
          <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
      </div>

      {/* Main Panel */}
      <div className="lecturer-panel">

{/**********************************************************************************************************************/}





{selectedOption === "settleInvoice" && (
  <div className="settle-container">

    <h1 className="page-title">Balance Payable Invoice</h1>

    {/* Search Section */}
    <div className="card search-card">
      <h2 className="section-title">Search Invoice</h2>

      <div className="form-row">
        <div className="form-group">
          <label>Invoice Number</label>
          <input
            type="text"
            placeholder="Enter invoice number"
            value={searchInvoiceNo}
            onChange={(e) => setSearchInvoiceNo(e.target.value)}
          />
        </div>

        <button className="search-btn" onClick={searchInvoice}>
          Search
        </button>
      </div>
    </div>

    {/* Invoice Details After Search */}
    {foundInvoice && (
      <div className="card invoice-card">
        <h2 className="section-title">Invoice Details</h2>

        <div className="details-grid">
          <p><strong>Patient Name:</strong> {foundInvoice.to}</p>
          <p><strong>Remaining Balance:</strong> Rs. {foundInvoice.totalAmount.toFixed(2)}</p>
        </div>

        <div className="form-group mt-15">
          <label>Amount Paying Now</label>
          <input
            type="number"
            placeholder="Enter amount"
            value={settleAmount}
            onChange={(e) => setSettleAmount(e.target.value)}
          />
        </div>

        <button className="pay-btn" onClick={handleSettlePayment}>
          Settle Now
        </button>
      </div>
    )}
  </div>
)}
















     {selectedOption === "salesReport" && (
    <div className="sales-container">
      <h2 className="text-xl font-bold mb-4">Sales Report</h2>

      {/* Filter Controls */}
      <div className="filter-controls">
        <select
          value={filterMode}
          onChange={(e) => setFilterMode(e.target.value)}
        >
          <option value="daily">Daily</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </select>

        {filterMode === "daily" && (
          <input
            type="date"
            value={selectedDate.format("YYYY-MM-DD")}
            onChange={(e) => setSelectedDate(dayjs(e.target.value))}
          />
        )}

        {filterMode === "monthly" && (
          <input
            type="month"
            value={selectedDate.format("YYYY-MM")}
            onChange={(e) => setSelectedDate(dayjs(e.target.value))}
          />
        )}

        {filterMode === "yearly" && (
          <input
            type="number"
            min="2000"
            max="2100"
            value={selectedDate.format("YYYY")}
            onChange={(e) => setSelectedDate(dayjs(`${e.target.value}-01-01`))}
          />
        )}
      </div>

      {/* Summary */}
      <div className="summary">
        <p>
          Total {filterMode} Sale: <span>Rs. {totalSale.toLocaleString()}</span>
        </p>
        <p>
          Total {filterMode} Paid: <span>Rs. {totalPaid.toLocaleString()}</span>
        </p>
        <p>
          Total {filterMode} Payable Balance:{" "}
          <span>Rs. {totalPayable.toLocaleString()}</span>
        </p>
      </div>

      {/* Table */}
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Invoice No</th>
            <th>Customer</th>
            <th>Phone</th>
            <th>Payment Method</th>
            <th>Frame</th>
            <th>Lens</th>
            <th>Right Lens</th>
            <th>Left Lens</th>
            <th>PD</th>
            <th>SEG</th>
            <th>Full Price</th>
            <th>Advanced</th>
            <th>Payable Balance</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvoices.length > 0 ? (
            filteredInvoices.map((inv) => {
              const payable = (inv.amount || 0) - (inv.deductAmount || 0);
              return (
                <tr key={inv.id}>
                  <td>{inv.date}</td>
                  <td>{inv.invoiceNo}</td>
                  <td>{inv.to}</td>
                  <td>{inv.patientPhoneNo}</td>
                  <td>{inv.paymentMethod}</td>
                  <td>{inv.frame}</td>
                  <td>{inv.lens}</td>
                  <td>{inv.rightLens}</td>
                  <td>{inv.leftLens}</td>
                  <td>{inv.pd}</td>
                  <td>{inv.seg}</td>
                  <td>Rs. {inv.amount}</td>
                  <td>Rs. {inv.deductAmount}</td>
                  <td className="font-bold">Rs. {payable}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="14" style={{ textAlign: "center" }}>
                No records found for this period.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
      )}






{/**********************************************************************************************************************/}





        {selectedOption === "addPatient" && (
          <div className="patient-form-question">
          <h1 className="lecturer-panel-title">Add Patient</h1>
          <form onSubmit={handleSubmit} className="patient-form-container">
            <div className="form-group">
              <label>Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Date of Birth:</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
             
              />
            </div>

            <div className="form-group">
              <label>Sex:</label>
              {/* <select
                name="sex"
                value={formData.sex}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select> */}
              <select
                name="sex"
                value={formData.sex}
                onChange={handleChange}
                required
          
              >
                <option value="">Select Gender</option>
             
                <option    style={{ color: "black" }} value="male">Male</option>
                <option    style={{ color: "black" }} value="female">Female</option>
              </select>

            </div>

            <div className="form-group">
              <label>Telephone No:</label>
              <input
                type="tel"
                name="telephoneNo"
                value={formData.telephoneNo}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Mobile No:</label>
              <textarea
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email:</label>
              <textarea
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Address:</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-btn">Add Patient</button>
          </form>
        </div>
        )}


{/*******************************************************************************************************************/}



       {selectedOption === "viewPatients" && (
    <div className="patients-section">
    <h1 className="lecturer-panel-title">View All Patients</h1>
    
    {loading ? (
      <div className="loading-spinner">Loading...</div>
    ) : patients.length === 0 ? (
      <p className="no-patients">No patients found in the database.</p>
    ) : (
      <div className="patients-table-container">
        <table className="patients-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Date of Birth</th>
              <th>Sex</th>
              <th>Telephone</th>
              <th>Mobile No</th>
              <th>Email</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {patients.map(patient => (
              <tr key={patient.id}>
                <td>{patient.name}</td>
                <td>{patient.dateOfBirth}</td>
                <td>{patient.sex}</td>
                <td>{patient.telephoneNo}</td>
                <td>{patient.mobileNo}</td>
                <td>{patient.email}</td>
                <td>{patient.address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
        )}


{/*******************************************************************************************************************/}


          {selectedOption === "createInvoice" && userDetails && (
            <div className="create-invoice-dashboard-container">
            <div className="lecturer-panel">
              {selectedOption === "createInvoice" && userDetails && (
                <div className="create-invoice-section">
                  <h1 className="invoice-heading">Create Invoice</h1>
                <form className="invoice-form">

                  {/* Patient Details */}
                  <div className="form-section">
                    <h3>Patient Details</h3>

                        <div className="form-column-create-invoice">
                          <label htmlFor="invoiceNo">Invoice No</label>
                            <input type="text" id="invoiceNo"
                              value={invoiceNumber}
                              onChange={(e) => setInvoiceNumber(e.target.value)}
                              required
                            />
                        </div>


                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="to">Patient Name</label>
                        <input type="text" id="to" value={to} onChange={(e) => setTo(e.target.value)} required />
                      </div>

                      <div className="form-column-create-invoice">
                        <label htmlFor="patientPhoneNo">Patient's Phone No</label>
                        <input type="text" id="patientPhoneNo" value={patientPhoneNo} onChange={(e) => setPatientPhoneNo(e.target.value)} required />
                      </div>

                      <div className="form-column-create-invoice">
                        <label htmlFor="date">Date</label>
                        <input type="date" id="date" value={date} onChange={(e) => setDate(e.target.value)} required />
                      </div>
                    </div>
                  </div>

                  {/* Lens & Frame Section */}
                  <div className="form-section">
                    <h3>Lens & Frame Details</h3>
                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="frame">Frame</label>
                        <input type="text" id="frame" value={frame} onChange={(e) => setFrame(e.target.value)} />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="lens">Lens</label>
                        <input type="text" id="lens" value={lens} onChange={(e) => setLens(e.target.value)} />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="brand">Brands</label>
                      <select id="brand" value={brand} onChange={(e) => setBrand(e.target.value)} required>
                          <option value="">-- Select Brand --</option>
                          <option value="HOYA">HOYA</option>
                          <option value="NEOFORM">NEOFORM</option>
                          <option value="ZEISS">ZEISS</option>
                          <option value="ESSILOR">ESSILOR</option>
                        </select>
                      </div>
                    </div>




                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="rightLens">Right Lens Power</label>
                        <input type="text" id="rightLens" value={rightLens} onChange={(e) => setRightLens(e.target.value)} />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="leftLens">Left Lens Power</label>
                        <input type="text" id="leftLens" value={leftLens} onChange={(e) => setLeftLens(e.target.value)} />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="addPower">Add Power</label>
                        <input type="text" id="addPower" value={addPower} onChange={(e) => setAddPower(e.target.value)} />
                      </div>
                    </div>

                     {/* <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="description">Description</label>
                        <textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} />
                      </div>
                    </div> */}

                     <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="pd">PD</label>
                        <input type="text" id="pd" value={pd} onChange={(e) => setPd(e.target.value)} />
                      </div>
                    </div> 

                      <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice col-span-2">
                        <label htmlFor="seg">SEG</label>
                        <input type="text" id="seg" value={seg} onChange={(e) => setSeg(e.target.value)} />
                      </div>
                    </div> 

                  </div>

                  {/* Payment Section */}
                  <div className="form-section">
                    <h3>Payment Details</h3>
                    <div className="form-row-create-invoice">
                 

                      <div className="form-column-create-invoice">
                        <label htmlFor="paymentMethod">Payment Method</label>
                        <select id="paymentMethod" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} required>
                          <option value="">-- Select Payment Method --</option>
                          <option value="Cash">Cash</option>
                          <option value="Card">Card</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                          <option value="Direct Deposit">Direct Deposit</option>
                        </select>
                      </div>

                      <div className="form-column-create-invoice">
                        <label htmlFor="amount">Amount</label>
                        <input
                          type="number"
                          id="amount"
                          value={amount}
                          onChange={(e) => {
                            const value = e.target.value;
                            setAmount(value);
                            setTotalAmount(parseFloat(value) - parseFloat(deductAmount) || 0);
                          }}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="deductAmount">Advance Payment</label>
                        <input
                          type="number"
                          id="deductAmount"
                          value={deductAmount}
                          onChange={(e) => {
                            const value = e.target.value;
                            setDeductAmount(value);
                            setTotalAmount(parseFloat(amount) - parseFloat(value));
                          }}
                        />
                      </div>

                      <div className="form-column-create-invoice">
                        <label htmlFor="totalAmount">Balance Amount</label>
                        <input type="text" id="totalAmount" value={totalAmount} readOnly />
                      </div>
                    </div>
                  </div>

                  <button type="button" onClick={handleCreateInvoice} className="create-button">
                    Create Invoice
                  </button>
                </form>

                </div>
              )}
            </div>
            </div>
           )}


{/*****************************************************************************************************************************/}


{selectedOption === "viewInvoice" && (
  <div className="home-section">
   <h1 className="view-all-invoice-heading">View All Invoices</h1>
    <div className="invoice-header-container">


<div className="invoice-filters">

  {/* Status Filter */}
  <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
    className="invoice-filter-select"
  >
    <option value="">All Status</option>
    <option value="Sent">Sent</option>
    <option value="Not Sent">Not Sent</option>
    <option value="Done">Done</option>
    <option value="Delivered">Delivered</option>
    <option value="Pending">Pending</option>
    <option value="Claim only">Claim only</option>
    <option value="Cancelled">Cancelled</option>
    <option value="Redo">Redo</option>
    <option value="OFTC">OFTC</option>
    <option value="Stop Work">Stop Work</option>
  </select>

  {/* Month Filter */}
  <select
    value={monthFilter}
    onChange={(e) => setMonthFilter(e.target.value)}
    className="invoice-filter-select"
  >
    <option value="">All Months</option>
    <option value="01">January</option>
    <option value="02">February</option>
    <option value="03">March</option>
    <option value="04">April</option>
    <option value="05">May</option>
    <option value="06">June</option>
    <option value="07">July</option>
    <option value="08">August</option>
    <option value="09">September</option>
    <option value="10">October</option>
    <option value="11">November</option>
    <option value="12">December</option>
  </select>

  {/* Date Range */}
  <input
    type="date"
    value={startDate}
    onChange={(e) => setStartDate(e.target.value)}
    className="invoice-filter-date"
  />

  <input
    type="date"
    value={endDate}
    onChange={(e) => setEndDate(e.target.value)}
    className="invoice-filter-date"
  />

</div>






   

      <div className="invoice-actions">
        <input
          type="text"
          placeholder="Search by name or invoice number..."
          className="invoice-search"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />

        <button onClick={handleDownload} className="export-button">
          Export All Invoices
        </button>

      </div>

    </div>

    <div className="invoices-container"> 
      <table className="invoices-table">
        <thead>
          <tr>
            <th>Invoice Number</th>
            <th>Patient Phone No</th>
            <th>To</th>
            <th>Date</th>
            <th>Status</th>
            <th>Frame</th>
            <th>Lens</th>
            <th>Add Power</th>
            <th>PD</th>
            <th>SEG</th>
            <th>Brand</th>
            <th>Right Lens Power</th>
            <th>Left Lens Power</th>
            <th>Payment Method</th>
            <th>Total Amount</th>
            <th>Advanced Payment</th>
            <th>Balance Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvoices.length > 0 ? (
            filteredInvoices.map((invoice) => (
              <tr key={invoice.id}>
                <td>{invoice.invoiceNo}</td>
                <td>{invoice.patientPhoneNo}</td>
                <td>{invoice.to}</td>
                <td>{invoice.date}</td>
                <td>{invoice.status}</td>
                <td>{invoice.frame}</td>
                <td>{invoice.lens}</td>
                 <td>{invoice.addPower}</td>
                <td>{invoice.pd}</td>
                 <td>{invoice.seg}</td>
               
                <td>{invoice.brand}</td>
                <td>{invoice.rightLens}</td>
                <td>{invoice.leftLens}</td>
                <td>{invoice.paymentMethod}</td>
                <td>{invoice.amount}</td>
                <td>{invoice.deductAmount}</td>
                <td>{invoice.totalAmount}</td>
     


                      <td>
                        <div className="invoice-actions-container">
         <td>
  <select
    value={invoice.status || "Pending"}
    onChange={(e) => handleStatusChange(invoice.id, e.target.value)}
    className={`status-select status-${invoice.status?.toLowerCase().replace(" ", "-")}`}
  >
    <option value="Sent">Sent</option>
    <option value="Not Sent">Not Sent</option>
    <option value="Done">Done</option>
    <option value="Delivered">Delivered</option>
    <option value="Pending">Pending</option>
    <option value="Claim only">Claim only</option>
    <option value="Cancelled">Cancelled</option>
    <option value="Redo">Redo</option>
    <option value="OFTC">OFTC</option>
    <option value="Stop Work">Stop Work</option>
  </select>
</td>

<button 
  onClick={() => generatePDF(invoice)}
  className="download-pdf-button"
>
  <span>
    {/* Download Icon */}
    <svg xmlns="http://www.w3.org/2000/svg" 
         width="20" height="20" 
         fill="currentColor" 
         viewBox="0 0 24 24">
      <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
    </svg>
  </span>
</button>

<button 
  onClick={() => handleDeleteInvoice(invoice.id)}
  className="delete-button"
>
  <span>
    {/* Trash Icon */}
    <svg xmlns="http://www.w3.org/2000/svg" 
         width="20" height="20" 
         fill="currentColor" 
         viewBox="0 0 24 24">
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
    </svg>
  </span>
</button>

                        </div>
                      </td>


              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No invoices found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}




{/*******************************************************************************************************************/}

              

{selectedOption === "viewPatients" && (
  <div className="patients-section">
    <div className="patients-header">
      <h1 className="lecturer-panel-title">View All Patients</h1>
      <button onClick={handleDownloadPatients} className="patients-excel">
          Export to Excel
        </button>
      <div className="patients-actions">
        <input
          type="text"
          placeholder="Search by name..."
          className="patient-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

      </div>
    </div>

    {loading ? (
      <div className="loading-spinner">Loading...</div>
    ) : filteredPatients.length === 0 ? (
      <p className="no-patients">
        {searchTerm ? "No matching patients found" : "No patients found in the database"}
      </p>
    ) : (
      <div className="patients-table-container">
        <table className="patients-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Date of Birth</th>
              <th>Sex</th>
              <th>Telephone</th>
              <th>Mobile No</th>
              <th>Address</th>
              <th>Follow Up Date</th>
              <th>Follow Up Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredPatients.map(patient => (
              <tr key={patient.id}>
                <td>{patient.name}</td>
                <td>{patient.dateOfBirth}</td>
                <td>{patient.sex}</td>
                <td>{patient.telephoneNo}</td>
                <td>{patient.mobileNo}</td>
                <td>{patient.address}</td>
                <td>{patient.followUpDate || "N/A"}</td>
                <td>{patient.followUpDescription}</td>


                <td>
                  <div className="patient-actions-container">
                    <button 
                      onClick={() => setEditingPatient(patient)}
                      className="edit-patient-btn"
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDeletePatient(patient.id)}
                      className="delete-patient-btn"
                    >
                      Delete
                    </button>
                  </div>
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    {/* Edit Patient Modal */}
    {editingPatient && (
      <div className="modal-overlay">
        <div className="edit-patient-modal">
          <h2>Edit Patient Details</h2>
          <form onSubmit={handleUpdatePatient}>
            <div className="form-group">
              <label>Name:</label>
              <input
                type="text"
                value={editingPatient.name || ""}
                onChange={(e) => setEditingPatient({...editingPatient, name: e.target.value})}
                required
              />
            </div>
            
            {/* Include all other patient fields similarly */}
            
            <div className="form-group">
              <label>Follow Up Date:</label>
              <input
                type="date"
                value={editingPatient.followUpDate || ""}
                onChange={(e) => setEditingPatient({...editingPatient, followUpDate: e.target.value})}
              />
            </div>
            
            <div className="form-group">
              <label>Follow Up Description:</label>
              <textarea
                value={editingPatient.followUpDescription || ""}
                onChange={(e) => setEditingPatient({...editingPatient, followUpDescription: e.target.value})}
                rows="3"
              />
            </div>
            
            <div className="modal-actions">
              <button type="button" className="cancel-btn-patient" onClick={() => setEditingPatient(null)}>
                Cancel
              </button>
              <button type="submit" className="save-btn-patient">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    )}
  </div>
)}


















{/* {selectedOption === "consultation" && (
  <div className="student-dashboard-container">
    <div className="lecturer-panel">
      <div className="home-section">
        <h1 className="invoice-heading">Consultation Invoice</h1>
        <form className="invoice-form">
          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="invoiceNo">Invoice No</label>
              <input
                type="text"
                id="invoiceNo"
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
                placeholder="INV-001"
                required
              />
            </div>
            <div className="form-column-create-invoice">
              <label htmlFor="date">Date</label>
              <input
                type="date"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="to">Patient Name</label>
              <input
                type="text"
                id="to"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                placeholder="Enter patient name"
                required
              />
            </div>
          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Consultation details"
                rows={3}
                required
              />
            </div>
          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="amount">Amount (Rs.)</label>
              <input
                type="number"
                id="amount"
                value={amount}
                onChange={(e) => {
                  const value = e.target.value;
                  setAmount(value);
                  setTotalAmount(parseFloat(value) - parseFloat(deductAmount) || 0);
                }}
                placeholder="0.00"
                min="0"
                step="0.01"
                required
              />
            </div>

          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="totalAmount">Total Amount (Rs.)</label>
              <input
                type="text"
                id="totalAmount"
                value={(parseFloat(amount || 0) - parseFloat(deductAmount || 0)).toFixed(2)}
                readOnly
              />
            </div>
          </div>

          <button
            type="button"
            onClick={handleCreateConsultationInvoice}
            className="create-button"
          >
            Create Consultation Invoice
          </button>
        </form>
      </div>
    </div>
  </div>
)} */}


{/* {selectedOption === "previousConsultation" && (
  <div className="salary-table-container">
    <h1 className="lecturer-panel-title">View Previous Consultation</h1>
    
    <div className="table-responsive">
      <table className="invoice-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Date</th>
            <th>Patient Name</th>
            <th>Description</th>
            <th>Amount (Rs.)</th>
            <th>Total Amount (Rs.)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {consultationInvoices.map((invoice) => (
            <tr key={invoice.id}>
              <td>{invoice.invoiceNo}</td>
              <td>{invoice.date}</td>
              <td>{invoice.patientName}</td>
              <td className="description-cell">{invoice.description}</td>
              <td>{invoice.amount.toFixed(2)}</td>
              <td>{invoice.totalAmount.toFixed(2)}</td>
              <td>
                <button 
                  className="view-btn"
                  onClick={() => handleViewInvoice(invoice)}
                >
                  View
                </button>
  
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div> */}
    
    {/* View Invoice Modal */}
    {/* {selectedInvoice && (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h2>Invoice Details</h2>
            <button 
              className="close-btn"
              onClick={() => setSelectedInvoice(null)}
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            <p><strong>Invoice No:</strong> {selectedInvoice.invoiceNo}</p>
            <p><strong>Date:</strong> {selectedInvoice.date}</p>
            <p><strong>Patient:</strong> {selectedInvoice.patientName}</p>
            <p><strong>Description:</strong> {selectedInvoice.description}</p>
            <p><strong>Amount:</strong> Rs. {selectedInvoice.amount.toFixed(2)}</p>
            <p><strong>Total Amount:</strong> Rs. {selectedInvoice.totalAmount.toFixed(2)}</p>
          </div>
        </div>
      </div>
    )}
  </div>
)} */}










{selectedOption === "eyeExam" && (
    <div className="eye-exam-section">
    <h1 className="lecturer-panel-title">Create Eye Exam Report</h1>
    
    <form onSubmit={handleEyeExamSubmit} className="eye-exam-form">
      {/* Patient Information */}
      <div className="form-section">
        <h2>Patient Information</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Patient Name *</label>
            <input 
              type="text" 
              value={patientName}
              onChange={(e) => setPatientName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Date *</label>
            <input 
              type="date" 
              value={examDate}
              onChange={(e) => setExamDate(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            {/* <label>Patient ID</label>
            <input 
              type="text" 
              value={patientId}
              onChange={(e) => setPatientId(e.target.value)}
            /> */}

            <div className="form-group">
            <label>Date of Birth *</label>
            <input 
              type="date" 
              value={dob}
              onChange={(e) => setDob(e.target.value)}
         
            />
          </div>

          </div>
          <div className="form-group">
            <label>Age</label>
            <input 
              type="text" 
              value={age}
              onChange={(e) => setAge(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Gender</label>
            <select 
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">Select</option>
              <option    style={{ color: "black" }} value="Male">Male</option>
              <option    style={{ color: "black" }} value="Female">Female</option>
          
            </select>
          </div>

          <div className="form-group">
            <label>Contact No</label>
            <input 
              type="text" 
              value={contactNo}
              onChange={(e) => setContactNo(e.target.value)}
            />
          </div>

          {/* <div className="form-group">
            <label>Email Address</label>
            <input 
              type="text" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div> */}

        </div>
      </div>

      {/* History Taking */}
      <div className="form-section">
        <h2>History Taking</h2>
        <div className="history-form-group">
          <label>Chief Complaint</label>
          <textarea 
            value={chiefComplaint}
            onChange={(e) => setChiefComplaint(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>HPC (History of Present Complaint)</label>
          <textarea 
            value={hpc}
            onChange={(e) => setHpc(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Past Ocular History</label>
          <textarea 
            value={pastOcularHistory}
            onChange={(e) => setPastOcularHistory(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Medical History</label>
          <textarea 
            value={medicalHistory}
            onChange={(e) => setMedicalHistory(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Family Ocular History</label>
          <textarea 
            value={familyOcularHistory}
            onChange={(e) => setFamilyOcularHistory(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Social History</label>
          <textarea 
            value={socialHistory}
            onChange={(e) => setSocialHistory(e.target.value)}
            rows="2"
          />
        </div>
      </div>





{/* External Examination */}

{/* Lids */}
<div className="exam-form-group">
  <label>Lids</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={lidsLeft}
        onChange={(e) => setLidsLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye lids condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={lidsRight}
        onChange={(e) => setLidsRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye lids condition"
      />
    </div>
  </div>
</div>

{/* Conjunctiva */}
<div className="exam-form-group">
  <label>Conjunctiva</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={conjunctivaLeft}
        onChange={(e) => setConjunctivaLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye conjunctiva condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={conjunctivaRight}
        onChange={(e) => setConjunctivaRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye conjunctiva condition"
      />
    </div>
  </div>
</div>

{/* Cornea */}
<div className="exam-form-group">
  <label>Cornea</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={corneaLeft}
        onChange={(e) => setCorneaLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye cornea condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={corneaRight}
        onChange={(e) => setCorneaRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye cornea condition"
      />
    </div>
  </div>
</div>

{/* Sclera */}
<div className="exam-form-group">
  <label>Sclera</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={scleraLeft}
        onChange={(e) => setScleraLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye sclera condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={scleraRight}
        onChange={(e) => setScleraRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye sclera condition"
      />
    </div>
  </div>
</div>

{/* A/C (Anterior Chamber) */}
<div className="exam-form-group">
  <label>A/C (Anterior Chamber)</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={acLeft}
        onChange={(e) => setAcLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye A/C condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={acRight}
        onChange={(e) => setAcRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye A/C condition"
      />
    </div>
  </div>
</div>

{/* Lens */}
<div className="exam-form-group">
  <label>Lens</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={lensLeft}
        onChange={(e) => setLensLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye lens condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={lensRight}
        onChange={(e) => setLensRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye lens condition"
      />
    </div>
  </div>
</div>

{/* Vitreous */}
<div className="exam-form-group">
  <label>Vitreous</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={vitreousLeft}
        onChange={(e) => setVitreousLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye vitreous condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={vitreousRight}
        onChange={(e) => setVitreousRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye vitreous condition"
      />
    </div>
  </div>
</div>











      {/* Family History */}
      <div className="form-section">
        <h2>Family History</h2>
        <div className="checkbox-group">
          <label>
            <input 
              type="checkbox" 
              name="poag"
              checked={familyHistory.poag}
              onChange={handleFamilyHistoryChange}
            />
            FHx POAG
          </label>
          <label>
            <input 
              type="checkbox" 
              name="amd"
              checked={familyHistory.amd}
              onChange={handleFamilyHistoryChange}
            />
            FHx AMD
          </label>
          <label>
            <input 
              type="checkbox" 
              name="dm"
              checked={familyHistory.dm}
              onChange={handleFamilyHistoryChange}
            />
            FHx DM
          </label>
          <div className="custom-condition">
            <input 
              type="text" 
              name="other"
              value={familyHistory.other}
              onChange={handleFamilyHistoryChange}
              placeholder="Other family history"
            />
          </div>
        </div>
      </div>

      {/* Visual Acuity */}
      <div className="form-section">
        <h2>Visual Acuity</h2>
        <div className="va-grid">
          <div className="va-header">
            <div></div>
            <div>OD</div>
            <div>OS</div>
          </div>
          <div className="va-row">
            <div className="va-test">C∕C</div>
            <input 
              type="text" 
              name="od_cg"
              value={visualAcuity.od_cg}
              onChange={handleVisualAcuityChange}
            />
            <input 
              type="text" 
              name="os_cg"
              value={visualAcuity.os_cg}
              onChange={handleVisualAcuityChange}
            />
          </div>
          <div className="va-row">
            <div className="va-test">S∕C</div>
            <input 
              type="text" 
              name="od_sg"
              value={visualAcuity.od_sg}
              onChange={handleVisualAcuityChange}
            />
            <input 
              type="text" 
              name="os_sg"
              value={visualAcuity.os_sg}
              onChange={handleVisualAcuityChange}
            />
          </div>
          <div className="va-row">
            <div className="va-test">P∕H</div>
            <input 
              type="text" 
              name="od_ph"
              value={visualAcuity.od_ph}
              onChange={handleVisualAcuityChange}
            />
            <input 
              type="text" 
              name="os_ph"
              value={visualAcuity.os_ph}
              onChange={handleVisualAcuityChange}
            />
          </div>

            <div className="va-row">
            <div className="va-test">PD</div>
            <input 
              type="text" 
              name="od_pd"
              value={visualAcuity.od_pd}
              onChange={handleVisualAcuityChange}
            />
            <input 
              type="text" 
              name="os_pd"
              value={visualAcuity.os_pd}
              onChange={handleVisualAcuityChange}
            />
          </div>

            <div className="va-row">
            <div className="va-test">SEG</div>
           <input 
  type="text" 
  name="seg_va"    // ✅ match state
  value={visualAcuity.seg_va}
  onChange={handleVisualAcuityChange}
/>
          </div>


        </div><br /><br />
        
        <div className="va-test">CT</div>
        <input 
              type="text" 
              name="ct"
              value={visualAcuity.ct}
              onChange={handleVisualAcuityChange}
            />
              <div className="va-test">NPC</div>
            <input 
              type="text" 
              name="npc"
              value={visualAcuity.npc}
              onChange={handleVisualAcuityChange}
            />
          <div className="va-test">OM</div>
           <input 
              type="text" 
              name="om"
              value={visualAcuity.om}
              onChange={handleVisualAcuityChange}
            />
      </div>



      {/* Fundi */}
      <div className="form-section">
        <h2>Fundi</h2>
        <div className="va-grid">
          <div className="form-group">
            <label>Description</label>
            <input 
              type="text" 
              value={fundi}
              onChange={(e) => setFundi(e.target.value)}
            />
          </div>
            </div>
      </div>






{/* Hb Rx */}
<div className="form-section">
        <h2>Hb Rx</h2>
        <div className="refraction-grid">
          <div className="refraction-header">
            <div></div>
            <div>Sph</div>
            <div>Cyl</div>
            <div>Axis</div>
            <div>Vision</div>
          </div>
          <div className="refraction-row">
            <div>OD</div>
            <input 
              type="text" 
              name="hb_od_sph"
              value={hbrx.hb_od_sph}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="hb_od_cyl"
              value={hbrx.hb_od_cyl}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="hb_od_axis"
              value={hbrx.hb_od_axis}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="hb_od_vision"
              value={hbrx.hb_od_vision}
              onChange={handleHbrxChange}
            />
          </div>
          <div className="refraction-row">
            <div>OS</div>
            <input 
              type="text" 
              name="rx_os_sph"
              value={hbrx.rx_os_sph}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="rx_os_cyl"
              value={hbrx.rx_os_cyl}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="rx_os_axis"
              value={hbrx.rx_os_axis}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="rx_os_vision"
              value={hbrx.rx_os_vision}
              onChange={handleHbrxChange}
            />
          </div>
        </div>
      </div>








      {/* Refraction */}
      <div className="form-section">
        <h2>Refraction</h2>
        <div className="refraction-grid">
          <div className="refraction-header">
            <div></div>
            <div>Sph</div>
            <div>Cyl</div>
            <div>Axis</div>
            <div>Vision</div>
          </div>
          <div className="refraction-row">
            <div>OD</div>
            <input 
              type="text" 
              name="od_sph"
              value={refraction.od_sph}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="od_cyl"
              value={refraction.od_cyl}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="od_axis"
              value={refraction.od_axis}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="od_vision"
              value={refraction.od_vision}
              onChange={handleRefractionChange}
            />
          </div>
          <div className="refraction-row">
            <div>OS</div>
            <input 
              type="text" 
              name="os_sph"
              value={refraction.os_sph}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="os_cyl"
              value={refraction.os_cyl}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="os_axis"
              value={refraction.os_axis}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="os_vision"
              value={refraction.os_vision}
              onChange={handleRefractionChange}
            />
          </div>
        </div>
      </div>





      {/* Follow Up */}
      <div className="form-section">
        <h2>Follow Up</h2>
        <div className="form-row">
          <div className="form-group">
            <label>
              <input 
                type="checkbox" 
                checked={needsFollowUp}
                onChange={(e) => setNeedsFollowUp(e.target.checked)}
              />
              Needs Follow Up
            </label>
          </div>
          <div className="form-group">
            <label>Follow Up Date</label>
            <input 
              type="date" 
              value={followUpDate}
              onChange={(e) => setFollowUpDate(e.target.value)}
              disabled={!needsFollowUp}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Remarks</label>
          <textarea 
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            rows={4}
          />
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="submit-btn">Generate Eye Exam Report</button>
      </div>
    </form>
  </div>
)}





{selectedOption === "viewEyeExam" && (
    

  
  <div className="eye-exam-container">
    <div className="header-section">
      <h1 className="section-title">Eye Examination Records</h1>
      <div className="controls">
        <input 
          type="text" 
          placeholder="Search records..." 
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select 
          className="filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">All Records</option>
          <option value="today">Today</option>
          <option value="week">This Week</option>
          <option value="month">This Month</option>
        </select>

      {/* <button className="ecp-btn-eye-exam">Export as file</button> */}
        
      </div>
    </div>

    {filteredRecords.length === 0 ? (
      <div className="no-records">
        <img src="/empty-state.svg" alt="No records" className="empty-icon" />
        <p>No examination records found</p>
      </div>
    ) : (
      <div className="table-responsive">
        <table className="eye-exam-table">
          <thead>
            <tr>
              <th>Patient Name</th>
              <th>Patient ID</th>
              <th>Date</th>
              <th>Age</th>
              <th>Chief Complaint</th>
              <th>VA (OD/OS)</th>
              <th>PD (OD/OS)</th>
              <th>SEG</th>
              <th>Refrac (od_cyl & od_axis)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredRecords.map((record) => (
              <tr key={record.id} className="exam-row">
                <td>{record.patientInfo?.name}</td>
                <td>{record.patientInfo?.id || 'N/A'}</td>
                <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                <td>{record.patientInfo?.age || 'N/A'}</td>
                <td className="complaint-cell">
                  {record.history?.chiefComplaint?.substring(0, 30)}...
                </td>
                <td>
                  {record.visualAcuity?.od_cg || 'N/A'} / {record.visualAcuity?.os_cg || 'N/A'}
                </td>
                <td>
                  {record.refraction?.od_sph || 'N/A'} {record.refraction?.od_cyl || ''} x {record.refraction?.od_axis || ''}
                </td>

                <td>
                  {record.visualAcuity?.od_pd || 'N/A'} / {record.visualAcuity?.os_pd || 'N/A'}
                </td>
                <td>
                  {record.refraction?.seg_va || 'N/A'} 
                </td>

                <td>
                  <div className="action-buttons">
                    <button 
                      className="pdf-btn"
                      onClick={() => generateEyeExamPDF(record)}
                    >
                      <Download size={16} /> PDF
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
    {/* Record Detail Modal */}
    {selectedRecord && (
      <div className="modal-overlay">
        <div className="record-modal">
          <div className="modal-header">
            <h3>Exam Details</h3>
            <button onClick={() => setSelectedRecord(null)}>×</button>
          </div>
          <div className="modal-content">
            <div className="patient-details">
              <h4>{selectedRecord.patientInfo?.name}</h4>
              <p>ID: {selectedRecord.patientInfo?.id}</p>
              <p>Age: {selectedRecord.patientInfo?.age} | Gender: {selectedRecord.patientInfo?.gender}</p>
            </div>
            
            <div className="section">
              <h5>History</h5>
              <p><strong>Chief Complaint:</strong> {selectedRecord.history?.chiefComplaint}</p>
              <p><strong>HPC:</strong> {selectedRecord.history?.hpc}</p>
            </div>

            <div className="section">
              <h5>Examination</h5>
              <div className="two-column">
                <div>
                  <p><strong>VA OD:</strong> {selectedRecord.visualAcuity?.od_cg}</p>
                  <p><strong>VA OS:</strong> {selectedRecord.visualAcuity?.os_cg}</p>
                </div>
                <div>
                  <p><strong>Refraction OD:</strong> {selectedRecord.refraction?.od_sph} {selectedRecord.refraction?.od_cyl} x {selectedRecord.refraction?.od_axis}</p>
                  <p><strong>Refraction OS:</strong> {selectedRecord.refraction?.os_sph} {selectedRecord.refraction?.os_cyl} x {selectedRecord.refraction?.os_axis}</p>
                </div>
              </div>
            </div>

            <button 
              className="generate-full-btn"
              onClick={() => generateEyeExamPDF(selectedRecord)}
            >
              Generate Full Report
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}










{selectedOption === "patienteyeExam" && (
  
  <div className="eye-exam-container">
  <div className="header-section">
    <h1 className="section-title">Eye Examination Report for Patient</h1>
    <div className="controls">
      <input 
        type="text" 
        placeholder="Search records..." 
        className="search-input"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <select 
        className="filter-select"
        onChange={(e) => setFilterOption(e.target.value)}
        value={filterOption}
      >
        <option value="all">All Records</option>
        <option value="today">Today</option>
        <option value="week">This Week</option>
        <option value="month">This Month</option>
      </select>

    {/* <button className="ecp-btn-eye-exam">Export as file</button> */}
      
    </div>
  </div>

  {filteredRecords.length === 0 ? (
    <div className="no-records">
      <img src="/empty-state.svg" alt="No records" className="empty-icon" />
      <p>No examination records found</p>
    </div>
  ) : (
    <div className="table-responsive">
      <table className="eye-exam-table">
        <thead>
          <tr>
            <th>Patient Name</th>
            <th>Patient ID</th>
            <th>Date</th>
            <th>Age</th>
            <th>Chief Complaint</th>
            <th>VA (OD/OS)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRecords.map((record) => (
            <tr key={record.id} className="exam-row">
              <td>{record.patientInfo?.name}</td>
              <td>{record.patientInfo?.id || 'N/A'}</td>
              <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
              <td>{record.patientInfo?.age || 'N/A'}</td>
              <td className="complaint-cell">
                {record.history?.chiefComplaint?.substring(0, 30)}...
              </td>
              <td>
                {record.visualAcuity?.od_cg || 'N/A'} / {record.visualAcuity?.os_cg || 'N/A'}
              </td>
             
              <td>
                <div className="action-buttons">
                  <button 
                    className="pdf-btn"
                    onClick={() => generatePatientEyeExam(record)}
                  >
                    <Download size={16} /> PDF
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}

</div>
)}



{/* Notification Panel */} 
{selectedOption === "notification" && (
  <div className="notification-section">
    <div className="notification-header">
      <h3>Patient Follow-ups</h3>
      <p className="notification-subtitle">
        {todayCount > 0 
          ? `${todayCount} follow-up${todayCount > 1 ? 's' : ''} today`
          : 'No follow-ups today'}
      </p>
    </div>

    <div className="notification-divider"></div>

    {error && (
      <div className="notification-error">
        <p>Error: {error}</p>
      </div>
    )}

    {loading ? (
      <div className="loading-notifications">
        <p>Loading notifications...</p>
      </div>
    ) : notifications.length === 0 ? (
      <div className="empty-notifications">
        <p>⚠️ No upcoming follow-ups found</p>
      </div>
    ) : (
      <div className="notification-list">
        {notifications.map((item) => (
          <div
            key={item.id}
            className={`notification-item ${item.isToday ? 'today-item' : ''}`}
            style={{
              borderLeft: `4px solid ${getPriorityColor(item.followUpDate)}`
            }}
          >
            <div
              className="notification-avatar"
              style={{ backgroundColor: getPriorityColor(item.followUpDate) }}
            >
              {item.followUpDate.getDate()}
            </div>

            <div className="notification-content">
              <p className={`notification-title ${item.isToday ? 'today-title' : ''}`}>
                {item.patientName}
              </p>

              <p className="notification-date">Follow-up: {item.formattedDate}</p>

              {item.telephoneNo && (
                <p className="notification-notes">
                  📞 Tel: {item.telephoneNo}
                </p>
              )}

              {item.followUpDescription && (
                <p className="notification-notes">
                  📝 {item.followUpDescription}
                </p>
              )}

              {item.notes && (
                <p className="notification-notes">{item.notes}</p>
              )}
            </div>

            <div className="notification-extra">
              <p className="notification-days">
                {item.isToday 
                  ? 'TODAY' 
                  : `${item.daysDifference} days`}
              </p>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
)}




             
           

      </div>
    </div>
  );
};

export default Body;
